import styled from "styled-components";
import { FiShield, FiTrendingUp, FiUsers } from "react-icons/fi";
import { fontFamily } from "../../shared/styles/theme";
import { primaryColor, secondaryBlueColor } from "../../shared/styles/color";
import heroMan from "../../../assets/images/how-it-works-hero-man.png";

const FEATURES = [
  {
    icon: FiShield,
    title: "Secure & Trusted",
    text: "Your data is protected with top level security.",
  },
  {
    icon: FiUsers,
    title: "Manage Everything",
    text: "Access your projects, messages, and payments in one place.",
  },
  {
    icon: FiTrendingUp,
    title: "Grow Your Business",
    text: "Find talent, build relationships, and achieve more.",
  },
];

const LoginAds = () => {
  return (
    <Wrap>
      <Badge>
        <Sparkle aria-hidden>✨</Sparkle>
        Welcome back!
      </Badge>

      <Headline>
        Glad to see you back on <Accent>Liber</Accent>
      </Headline>

      <Subhead>
        Log in to your account and continue connecting with great talent and amazing
        opportunities.
      </Subhead>

      <FeatureList>
        {FEATURES.map(({ icon: Icon, title, text }) => (
          <FeatureItem key={title}>
            <FeatureIcon aria-hidden>
              <Icon size={18} strokeWidth={2} />
            </FeatureIcon>
            <div>
              <FeatureTitle>{title}</FeatureTitle>
              <FeatureText>{text}</FeatureText>
            </div>
          </FeatureItem>
        ))}
      </FeatureList>

      <IllustrationArea aria-hidden>
        <HeroImg src={heroMan} alt="" />
      </IllustrationArea>
    </Wrap>
  );
};

export default LoginAds;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  height: 100%;
  padding: 8px 0 8px;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: ${secondaryBlueColor};
  color: ${primaryColor};
  font-family: ${fontFamily.font};
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 20px;
`;

const Sparkle = styled.span`
  font-size: 14px;
  line-height: 1;
`;

const Headline = styled.h1`
  font-family: ${fontFamily.font};
  font-size: clamp(1.75rem, 3.2vw, 2.35rem);
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
  margin: 0 0 14px;
  max-width: 440px;
  letter-spacing: -0.02em;
`;

const Accent = styled.span`
  color: ${primaryColor};
`;

const Subhead = styled.p`
  font-family: ${fontFamily.font};
  font-size: 15px;
  line-height: 1.65;
  color: #6b7280;
  margin: 0 0 28px;
  max-width: 420px;
`;

const FeatureList = styled.ul`
  list-style: none;
  margin: 0 0 28px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: 420px;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

const FeatureIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${secondaryBlueColor};
  color: ${primaryColor};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const FeatureTitle = styled.h3`
  margin: 0 0 2px;
  font-family: ${fontFamily.font};
  font-size: 15px;
  font-weight: 700;
  color: #111827;
`;

const FeatureText = styled.p`
  margin: 0;
  font-family: ${fontFamily.font};
  font-size: 13px;
  line-height: 1.45;
  color: #6b7280;
`;

const IllustrationArea = styled.div`
  width: 100%;
  max-width: 420px;
  margin-top: auto;
`;

const HeroImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
`;
